import { render, staticRenderFns } from "./MailServicePreview.vue?vue&type=template&id=bb2a418a"
import script from "./MailServicePreview.vue?vue&type=script&lang=ts"
export * from "./MailServicePreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports